import {
  BASE_FILTER_COLUMNS,
  EPISODE_FILTER_COLUMN,
} from "tap/pages/Offers/components/grid/config/columnOptions.js";

/** Format TAP Offer Status for display in filters */
export function formatTapOfferStatus(status) {
  switch (status) {
    case "PENDING":
      return "Pending";
    case "PUSHED":
    case "OFFER_IN_PAST_SYSTEM_UPDATED":
      return "Pushed";
    case "DUPLICATE":
    case "DUPLICATE_DIFFJOB":
      return "Duplicate";
    case "SYSTEM_UPDATED":
      return "System Updated";
    case "USER_MODIFIED":
      return "User Modified";
    case "SYSTEM_UPDATED_OFFER_ACTIVE":
      return "Offer Active - System Updated";
    case "USER_MODIFIED_OFFER_ACTIVE":
      return "Offer Active - User Modified";
    case "INACTIVE_DEAL":
      return "Inactive Deal";
    case "BLANK_DEAL_FIELDS":
      return "Blank Deal Fields";
    case "RIGHTS_ISSUE":
      return "Rights Issue";
    case "MISSING_PRICING":
      return "Missing Pricing";
    case "TO_DELETE":
      return "To Delete";
    case "SYSTEM_CREATED":
      return "System Created";
    case "INFO_RESTRICTIONS":
      return "Info Restrictions";
    default:
      return status;
  }
}

/** Get display label for a field value */
export function getFieldLabel(field, value) {
  if (field === "tapOfferStatus") {
    return formatTapOfferStatus(value);
  }
  if (field === "needsAudit" || field === "readyToPublish") {
    return value === "true" || value === true ? "Yes" : "No";
  }
  return value;
}

/** Extract unique values from offers for a given field */
export function getUniqueOptions(offers, field) {
  if (!offers || !Array.isArray(offers)) return [];

  const uniqueValues = new Set();
  offers.forEach((offer) => {
    const value = offer[field];
    if (value !== null && value !== undefined && value !== "") {
      uniqueValues.add(String(value));
    }
  });

  return Array.from(uniqueValues)
    .sort((a, b) => {
      const labelA = getFieldLabel(field, a);
      const labelB = getFieldLabel(field, b);
      const numA = parseFloat(labelA);
      const numB = parseFloat(labelB);
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
      return String(labelA).localeCompare(String(labelB));
    })
    .map((value) => ({
      label: getFieldLabel(field, value),
      value,
    }));
}

/**
 * Filter sidebar column definitions (episode column when feature flag is on).
 * @param {boolean} hasEpisodeFeature
 * @returns {Array<{ field: string, label: string }>}
 */
export function getOffersFilterColumns(hasEpisodeFeature) {
  if (hasEpisodeFeature) {
    const withEpisode = [...BASE_FILTER_COLUMNS];
    const tierIdx = withEpisode.findIndex((c) => c.field === "tier");
    if (tierIdx > -1) {
      withEpisode.splice(tierIdx + 1, 0, EPISODE_FILTER_COLUMN);
    }
    return withEpisode;
  }
  return BASE_FILTER_COLUMNS;
}

/**
 * Builds MultiSelect options per filter field from offer rows.
 * @param {Array} offers
 * @param {Array<{ field: string, label: string }>} filterColumns
 * @returns {Record<string, Array<{ label: string, value: string }>>}
 */
export function buildOffersFilterOptions(offers, filterColumns) {
  const options = {};
  (filterColumns || []).forEach((col) => {
    options[col.field] = getUniqueOptions(offers, col.field);
  });
  return options;
}
